export const boringStoriesData = {
    designs: {
        title: 'High-fidelity designs',
        images: {
            mobile: [
                'boringStories_mobile_1.png',
                'boringStories_mobile_2.png',
                'boringStories_mobile_3.png',
                'boringStories_mobile_4.png'
            ]
        }
    }
}
